import HCLDX from "@system/config/hcldx";
import Helper from "../../src/support/Helper";
import $ from "jquery";

class Product {
    static PRODUCT_INVENTORY = Helper.getInventoryUrl() + '/api/inventory/getinventory';
    static STOCK_ALERT_NOTIFY = Helper.getInventoryUrl() + '/api/inventory/stockalert/notify';
    static PRODUCT_PRICING = Helper.getPriceUrl() + '/api/pricing/getprice';
    static PRODUCT_PRICING_NEW = Helper.getPriceUrl() + '/api/pricing/getprices';
    static PRODUCT_LISTING = Helper.getApplicationUrl() + '/api/application/product/search';
    static PRODUCT_GROUPED_LISTING = Helper.getApplicationUrl() + '/api/application/product/manual/search';
    static PRODUCT_CATEGORY_LIST = Helper.getApplicationUrl() + '/api/application/product/category';
    static PRODUCT_LISTING_AZURE_SERVICE = 'https://fsp-global-product-keyword-dev.search.windows.net/indexes/productlisting/docs/search?api-version=2020-06-30-Preview';
    static PRODUCT_LISTING_SEND_MAIL = Helper.getProductUrl() + '/api/product/sendMail';
    static PRODUCT_DOCUMENT_LIST = Helper.getApplicationUrl() + '/api/application/product/documentsearch'
    static PRODUCT_VARIANT_ASSET_LIST = Helper.getApplicationUrl() + '/api/application/variantasset/search'
    static PRODUCT_ALTERNATIVE_DATA_LIST = Helper.getApplicationUrl() + '/api/application/product/subalternative'
    static AUTOSUGGEST_LISTING_BY_SEARCH_PARAM = Helper.getAutosuggestUrl() + '/search/resources/store/10151/sitecontent/webContentsBySearchTerm/select'
    static AUTOSUGGEST_LISTING_BY_SEARCH_PARAM_NEW = Helper.getAutosuggestUrl() + '/wcs/resources/avnet/fspsitecontent/webContentsBySearchTerm'
    static CHECK_DESIGN_AVAILABLITY = Helper.getDesignHubUrl() + '/api/designhub/checkexists'
    static GET_DESIGN_DATA = Helper.getDesignHubUrl() + '/api/designhub/getdesigns'
    static CHECK_DESIGNS_EXIST = Helper.getDesignHubUrl() + '/api/designhub/checkdesigns'
    static PRODUCT_REPORT_ERROR = Helper.getReportErrorUrl() + '/api/product/reportError'
    static PRODUCT_MANUFACTURE_EXTERNAL_SEARCH = Helper.getApplicationUrl() + '/api/application/product/urlCategoryManufacturerInfo'
    static UNIVERSAL_PRODUCT_SEARCH = Helper.getApplicationUrl() + '/api/application/product/auto/search'
    static UNIVERSAL_MANUFACTURERS_CATEGORY_SEARCH = Helper.getApplicationUrl() + '/api/application/product/auto/category/manufacturer'
    static PRODUCT_INVENTORY_FARNELL = Helper.getApplicationUrl() + '/api/application/product/getFarnellInventoryDetails'

    static autosuggest_param(value) {
        let c = {
            "storeId": 10151,
            "catalogId": 10001,
            "langId": -1,
            "orgEntityId": -2000,
            "contractId": 10006,
            "wt": "json",
            "profileName": "Avn_findWebContentBySearchTerm",
            "profileVideo": "Avn_findVideosBySearchTerm",
            "avnBusinessCategory": "",
        }
        if (c[value] !== undefined) {
            return c[value];
        }
        return value;
    }

    static product__ROHSCompliantCode(value) {
        let c = {
            "Y": "RoHS 6 Compliant",
            "X": "RoHS 6 Exempt",
            "N": "RoHS Non Complaint",
            "U": "UNDETERMINED",
            "C": "RoHS 10 Compliant",
            "E": "RoHS 10 Exempt",
        }
        if (c[value] !== undefined) {
            return c[value];
        }
        return value;
    }

    static getProductListingPageRouteURL(c = {}) {
        if (Object.entries(c).length > 0) {
            return HCLDX.baseURL() + '/products/c/search/?' + $.param(c);
        }
        return HCLDX.baseURL() + '/products/c/search/';
    }

    static getProductListingNotFoundPageRouteURL() {
        return HCLDX.baseURL() + '/shop/part-not-found';
    }

    static getProductDetailPageRouteURL() {
        //return HCLDX.baseURL() + '/products/product';
        // Due to page redirection issue commmented below things

        //by Hardik Sarodiya
        return HCLDX.baseURL() + '/product/:ManufacturerName/:ERPMFRPartNumber/:ItemNumber';
    }

    // By Hardik Sarodiya
    static getProductDetailPageRouteURLWithCustomParameter(product) {
        //return HCLDX.baseURL() + '/products/product';

        // Due to page redirection issue commmented below things
        //return HCLDX.baseURL() + '/product';
        let ManufacturerName = product.Manufacturer ? product.Manufacturer : product.manufacturerName ? product.manufacturerName : product.ManufacturerName ? product.ManufacturerName : ''
        let ItemNumber = product.ItemNumber ? product.ItemNumber : product.itemNumber ? product.itemNumber : ''

        // add ERPMFRPartNumber
        let ERPMFRPartNumber = product.ERPMFRPartNumber ? product.ERPMFRPartNumber : product.erpMfrPartNumber ? product.erpMfrPartNumber : ''

        let newUrl = HCLDX.baseURL() + '/product';
        if (ManufacturerName) {
            newUrl += "/" + ManufacturerName?.toLowerCase().replace(/\+/g, "and").replace(/\&/g, "and").replace(/\./g, "").replace(/\//g, "-").replace(/\,/g, "").replace(/\s/g, '-').replace(/\---/g, '-');
        }
        if (ERPMFRPartNumber) {
            newUrl += "/" + ERPMFRPartNumber.toLowerCase()
        }
        if (ItemNumber) {
            newUrl += "/" + ItemNumber.toLowerCase()
        }
        return newUrl;
    }
}

export default Product;